/**
 * isObjectFilter
 *
 * @author Dec Norton <decnorton@gmail.com>
 */

export function isObjectFilter() {
    return function(param) {
        return angular.isObject(param);
    };
}
